import React, { useContext, useEffect } from 'react';
import { Handle, Position } from 'reactflow';
import { FileIcon } from '@radix-ui/react-icons';
import { usePipeline } from '../../../context/PipelineContext'; // Import the context
import { NodeMappingContext } from '../../Canvas/Canvas';
import './InputNode.css';

const InputNode = ({ id, data }) => {
  const { session } = usePipeline();
  const { updateNodeMapping } = useContext(NodeMappingContext);
  
  // Find the node in the session state
  const nodeData = session.nodes.find(node => node.node_name === id);
  
  // If node data is not found in the session, use the data from the ReactFlow node
  const isConfigured = nodeData?.is_configured || true; // Default to true for loaded nodes
  const nodeType = nodeData?.node_params?.[0]?.type || data?.type || 'solar'; // Try to get type from session, then from node data, default to 'solar'
  
  // Update the node ID to name mapping when the component mounts
  useEffect(() => {
    if (id) {
      updateNodeMapping(id, id);
      console.log(`Updated node mapping for input node: ${id}`);
    }
  }, [id, updateNodeMapping]);

  return (
    <div className={`input-node ${isConfigured ? 'input-configured' : 'input-unconfigured'} ${nodeType}`}>
      <div className={`input-node-header ${isConfigured ? 'header-configured' : 'header-unconfigured'} ${nodeType}`}>
        <span>{id}</span>
        <div>
          <FileIcon/>
        </div>
      </div>
      <div className="input-node-content">
        {isConfigured ? (
          // Display configured node information
          <div className="node-info">
            <div className="info-row">
              <span className="info-label">Type:</span>
              <span className="info-value">{nodeType}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Interval:</span>
              <span className="info-value">{nodeData?.node_params?.[0]?.interval || data?.interval || 15} mins</span>
            </div>
          </div>
        ) : (
          // Display unconfigured message
          <div className="unconfigured-message">
            Not configured
          </div>
        )}
        <Handle
          type="source"
          position={Position.Right}
          id="output"
          className={`input-connection-point ${isConfigured ? 'connection-configured' : 'connection-unconfigured'} ${nodeType}`}
          isConnectable={isConfigured} // Only allow connections if the node is configured
          data-maxconnections="1" // Custom attribute to indicate this handle should only have one connection
        />
      </div>
    </div>
  );
};

export default InputNode;
